import { type FC, useEffect, useState } from 'react';
import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import { useMaintenance } from '../contexts/MaintenanceContext';

const Maintenance: FC = () => {
    const { end_date } = useMaintenance();
    const [endTimeDisplay, setEndTimeDisplay] = useState<string>('');


    useEffect(() => {
        if (!end_date) return;

        const updateTimerDisplay = () => {
            const endTime = new Date(end_date);



            // Format end time
            const options: Intl.DateTimeFormatOptions = {
                timeZone: 'Africa/Johannesburg',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
            };

            const dayOptions: Intl.DateTimeFormatOptions = {
                timeZone: 'Africa/Johannesburg',
                weekday: 'short',
                month: 'short',
                day: 'numeric',
            };

            const formattedDate = endTime.toLocaleDateString('en-ZA', dayOptions);
            const formattedTime = endTime.toLocaleTimeString('en-ZA', options);
            setEndTimeDisplay(`${formattedDate} at ${formattedTime} SAST`);

        };

        updateTimerDisplay();
        const interval = setInterval(updateTimerDisplay, 1000);

        return () => clearInterval(interval);
    }, [end_date]);

    return (
        <div className="min-h-screen bg-stone-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full">
                <div className="rounded-2xl bg-white border border-stone-200 shadow-sm overflow-hidden text-center">
                    {/* Top accent bar to match your app's brand */}
                    <div className="h-1.5 bg-[#e6186c] w-full" />

                    <div className="px-6 py-10">
                        <div className="flex justify-center mb-6">
                            <div className="rounded-full bg-[#e6186c]/5 p-3 ring-1 ring-[#e6186c]">
                                <WrenchScrewdriverIcon className="h-8 w-8 text-[#e6186c]" />
                            </div>
                        </div>

                        <h1 className="font-display text-3xl tracking-tight text-gray-900 mb-2">
                            System Update
                        </h1>

                        <p className="text-sm text-gray-600 leading-relaxed">
                            We are currently performing scheduled database maintenance to improve our platform performance.
                        </p>

                        <div className="mt-8 pt-6 border-t border-stone-100">
                            <span className="inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ring-1 text-[#e6186c] ring-[#e6186c] bg-[#e6186c]/5 animate-pulse">
                                Maintenance Mode Active
                            </span>

                            {/* ✅ Expected End Time */}
                            {endTimeDisplay && (
                                <div className="mt-4 space-y-2">
                                    <p className="text-xs text-gray-400 font-medium uppercase tracking-widest">
                                        Expected End Time  {endTimeDisplay}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Matches the table-footer/header style of your app */}
                    <div className="bg-stone-50/60 px-6 py-4 border-t border-stone-200">
                        <p className="text-[10px] text-gray-500 uppercase tracking-tight">
                            Platform Status: Updating
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Maintenance;